import { Component, OnInit, Type } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  FieldArrayType,
  FieldArrayTypeConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';

interface MultiInputProps extends FormlyFieldProps {
  addText?: string;
  maxItems?: number;
  minItems?: number;
}

export interface MultiInputTypeConfig<
  MultiInputProps,
> extends FieldArrayTypeConfig<MultiInputProps> {
  type: 'multi-input' | Type<MultiInputComponent>;
}

@Component({
  selector: 'vectronic-formly-multi-input',
  imports: [FormlyModule, MatIconButton, MatButton, MatIcon],
  templateUrl: './multi-input.component.html',
  styleUrls: ['./multi-input.component.scss'],
})
export class MultiInputComponent
  extends FieldArrayType<FieldArrayTypeConfig<MultiInputProps>>
  implements OnInit
{
  ngOnInit() {
    this.field.fieldGroup?.forEach(
      (child) => (child.id = `${child.id}-${this.field.key}.${child.key}`),
    );
  }

  addWithProperIds(i?: number, initialModel?: any, { markAsDirty } = { markAsDirty: true }) {
    this.add(i, initialModel, { markAsDirty });
    const lastChild = this.field.fieldGroup.at(this.field.fieldGroup.length - 1);
    lastChild.id = `${lastChild.id}-${this.field.key}.${lastChild.key}`;
  }

  isAddDisabled() {
    return (
      this.formControl.disabled ||
      this.formControl.invalid ||
      this.field.fieldGroup.length >= this.props.maxItems
    );
  }

  get addText() {
    return this.props?.addText || 'Add';
  }

  get maxItems() {
    return this.props?.maxItems ?? Infinity;
  }

  get minItems() {
    return this.props?.minItems ?? 0;
  }
}
